// src/theme/typography.ts
import type { Theme } from '@mui/material/styles';

const typography = (fontFamily: string): Theme['typography'] =>
    ({
        fontFamily:
            typeof fontFamily === 'undefined' || fontFamily === ''
                ? [
                      'Inter',
                      'sans-serif',
                      '-apple-system',
                      'BlinkMacSystemFont',
                      '"Segoe UI"',
                      'Roboto',
                      '"Helvetica Neue"',
                      'Arial',
                      'sans-serif"',
                      '"Apple Color Emoji"',
                      '"Segoe UI Emoji"',
                      '"Segoe UI Symbol"',
                  ].join(',')
                : fontFamily,

        fontSize: 13.125,

        // Headings
        h1: {
            fontSize: '6rem', // 96px
            lineHeight: 100 / 96, // ≈1.0417 (100px)
            fontWeight: 300,
        },
        h2: {
            fontSize: '3.75rem', // 60px
            lineHeight: 72 / 60, // 1.2     (72px)
            fontWeight: 300,
        },
        h3: {
            fontSize: '3rem', // 48px
            lineHeight: 56 / 48, // ≈1.1667 (56px)
            fontWeight: 400,
        },
        h4: {
            fontSize: '2.125rem', // 34px
            lineHeight: 42 / 34, // ≈1.2353 (42px)
            fontWeight: 400,
        },
        h5: {
            fontSize: '1.5rem', // 24px
            lineHeight: 32 / 24, // ≈1.3333 (32px)
            fontWeight: 400,
        },
        h6: {
            fontSize: '1.25rem', // 20px
            lineHeight: 32 / 20, // 1.6     (32px)
            fontWeight: 500,
        },

        // Subtitles
        subtitle1: {
            fontSize: '1rem', // 16px
            lineHeight: 28 / 16, // 1.75   (28px)
            fontWeight: 400,
        },
        subtitle2: {
            fontSize: '0.875rem', // 14px
            lineHeight: 22 / 14, // ≈1.5714 (22px)
            fontWeight: 500,
        },

        // Body
        body1: {
            fontSize: '0.875rem', // 14px
            lineHeight: 24 / 14, // ≈1.7143 (24px)
            fontWeight: 400,
        },
        body2: {
            fontSize: '0.875rem', // 14px
            lineHeight: 20 / 14, // ≈1.4286 (20px)
            fontWeight: 400,
        },

        // Button giữ nguyên nếu muốn
        button: {
            fontSize: '0.9375rem', // 15px (không đổi)
            lineHeight: 1.46667,
            textTransform: 'none',
        },

        // Caption & Overline
        caption: {
            fontSize: '0.75rem', // 12px
            lineHeight: 20 / 12, // ≈1.6667 (20px)
            fontWeight: 400,
            letterSpacing: '0.4px',
        },
        overline: {
            fontSize: '0.75rem', // 12px
            lineHeight: 32 / 12, // ≈2.6667 (32px)
            fontWeight: 400,
            letterSpacing: '0.8px',
        },
    }) as Theme['typography'];

export default typography;
